export default __webpack_public_path__ + "static/media/banner-mobile.3ef56fb4.jpg";